import Snappy from '../libs/snappy/snappy';
import objectFitImages from 'object-fit-images';

objectFitImages(document.querySelectorAll('img:not(.lazyload)'));

import '../components/resizement/scripts/resize';
import '../.modernizrrc';
import '../styles/main.scss';

require('./bootstrapComponents');
require('./globalConfigs');
require('./pollyfills');
require('./picturefill');
require('./utilities/hbs-helpers');
require('../libs/validation/serverValidation');

require('../components/accordion/scripts/accordion');
require('../components/alternate-dropdown/scripts/alternate-dropdown');
require('../components/articleTable/scripts/articleTable');
require('../components/backToTop/scripts/backToTop');
require('../components/breadcrumbs/scripts/breadcrumbs');
require('../components/campaign/scripts/campaign');
require('../components/carousel/scripts/carousel');
require('../components/cfa-nav/scripts/cfa-nav');
require('../components/cfa-search-results/scripts/cfa-clear-field');
require('../components/cfa-search-results/scripts/cfa-search-results');
require('../components/communityAwards/scripts/nominationForm');
require('../components/contactForm/scripts/contactForm');
require('../components/content-loader/scripts/contentLoader');
require('../components/contentPromo/scripts/contentPromo');
require('../components/contentPromoHero/scripts/contentPromoHero');
require('../components/contentPromoVideo/scripts/contentPromoVideo');
require('../components/cookie/scripts/cookie');
require('../components/dropdown/scripts/dropdown');
require('../components/faqs/scripts/faqs');
require('../components/featured-event/scripts/featured-event');
require('../components/filters/scripts/filters');
require('../components/footer/scripts/footer');
require('../components/gallery/scripts/gallery');
require('../components/inputField/scripts/inputField');
require('../components/lazyimages/scripts/lazyimages');
require('../components/media-gallery/scripts/media-gallery');
require('../components/modal/scripts/modal');
require('../components/pageMedia/scripts/pageMedia');
require('../components/quote/scripts/quote');
require('../components/relatedContent/scripts/relatedContent');
require('../components/responsive-video/scripts/responsive-video');
require('../components/rowHeading/scripts/rowHeading');
require('../components/rowStrip/scripts/rowStrip');
require('../components/scrollto/scripts/scrollto');
require('../components/signpostContentPromo/scripts/signpostContentPromo');
require('../components/signpostContentPromoHero/scripts/signpostContentPromoHero');
require('../components/signpostContentPromoLinkList/scripts/signpostContentPromoLinkList');
require('../components/signpostContentPromoQuote/scripts/signpostContentPromoQuote');
require('../components/subNavigation/scripts/subNavigation');
require('../components/sticky-menu/scripts/sticky-menu');
require('../components/tabs/scripts/tabs');
require('../components/textarea/scripts/textarea');
require('../components/tickets/scripts/tickets');
require('../components/topbar/scripts/topbar');
require('../components/tracking/scripts/tracking');
require('../components/usefulResources/scripts/usefulResources');
require('../components/video/scripts/video');
require('../components/video-seats/scripts/video');
require('../components/ws-enquiry-form/scripts/enquiry-form');
require('../components/ws-meetings-events/scripts/meetings-events');
require('../components/ws-sofa-to-seat/scripts/sofa-to-seat');
require('../components/ws-vfs/scripts/vfs');
require('../components/ws-signup-form/scripts/signup-form');
require('../components/ws-signup-welcome/scripts/signup-welcome'); 
require('../components/cw-enquiryform/scripts/enquiryform'); 
require('../components/cw-enquiryform/scripts/hospitalityenquiryform'); 
require('../components/comparisontool/scripts/comparisontool');  
require('../components/ws-events/scripts/events');
require('../components/ws-events/scripts/event-cards');
require('../components/cwm-package-details/scripts/package-details');
require('../components/cwm-event-card-signpost/scripts/event-card-signpost');
require('../components/cwm-event-description/scripts/cwm-event-description');
require('../components/cwm-header/scripts/cwm-header');
require('../components/cwm-header/scripts/cwm-switch-membership');
require('../components/cwm-event-filter/scripts/cwm-event-filter');
require('../components/cwm-event-filter/scripts/cwm-event-filter-card-pagination');
require('../components/cwm-custom-scripts/cwm-hero-personalisation');
require('../components/cwm-custom-scripts/cwm-edit-account-details');
require('../components/cwm-my-account-details/scripts/my-account-details');
require('../components/cwm-contact-preferences/scripts/cwm-contact-preferences');
require('../components/cwm-editmybank-details/scripts/editmybank-details');
require('../components/cwm-partner-offers-signpost/scripts/cwm-partner-offers-signpost');
require('../components/cwm-other-contacts-cmp/scripts/cwm-other-contacts-cmp');
require('../components/cwm-modal/scripts/cwm-modal');
require('../components/cwm-connection-event/cwm-countdown-timer');
require('../components/cwm-connection-event/cwm-guest-counter');
require('../components/cwm-connection-event/cwm-connection-api-integration');
require('../components/cwm-connection-event/cwm-connection-RSVP-integration');
require('../components/cwm-editmybank-details/scripts/jquery.mask');
require('../components/cwm-editmybank-details/scripts/bank-details-view');
require('../components/cwm-addsubcontacts-form/scripts/cwm-addsubcontacts-form');
require('../components/cwm-connections-attendee-details/scripts/cwm-connections-attendee-details');
require('../components/cwm-deleteAccount-details/scripts/cwm-deleteAccount-details');
require('../components/cwm-header/scripts/cwm-skip-link');
require('../components/cwm-account-manager/scripts/_cwm-account-manager');
require('../components/cw-header/scripts/_cw-header');
require('../components/cw-header/scripts/_cw-sticky-topbar');
require('../components/Hero-video/scripts/hero-video');
require('../components/video-signpost_carousel/scripts/video-signpost-carousel');
require('../components/cw-membership-slider/scripts/membership-slider');
require('../components/cw-membership-slider/scripts/membership-slider-card');
import carousel from '../components/cwm-gallery-carousel/scripts/cwm-carousel';
import carouselGlide from '../components/cwm-gallery-carousel/scripts/cwm-carousel-glide';
import carouselImageGallery from '../components/cwm-gallery-carousel/scripts/cwm-carousel-image-gallery';
// CAROUSEL

const carouselElements = document.querySelectorAll(
    '[data-behavior="carousel"]'
);
if (carouselElements) {  
    carouselElements.forEach(carouselElement => carousel({ carouselElement }));
}
    
// CAROUSEL GLIDE
const carouselGlideObject = document.querySelectorAll(
'[data-behavior="carousel-glide"]'
);

if (carouselGlideObject) {
carouselGlideObject.forEach(carouselGlideElement =>
    carouselGlide({ carouselGlideElement })
);
}

// Image Gallery
const imageGalleryObject = document.querySelectorAll(
'[data-behavior="carousel-image-gallery"]'
);

if (imageGalleryObject) {
imageGalleryObject.forEach(imageGalleryElement =>
    carouselImageGallery({ imageGalleryElement })
);
} 


Snappy.init();

const files = require.context('../assets/svg', true, /^\.\/.*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./scripts/main.js